import React from 'react';

import styled from 'styled-components';

import Switch from '@components/Gui/CustomSwitch';
import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import SelectionBar from '@components/Gui/SelectionBar';
import { ModelSelectorContainer } from '@components/Project/ProjectTransactions/Transactions/ProjectTransactionsUI';

const StyledSwitch = styled(Switch)`
    ${(props) => (props.$cancel ? props.theme.RedLineThrough(1) : 'text-decoration: none;')}
`;

const ModelSelectorNonBookingDates = ({
    models,
    updateModels,
    selectedEvent,
    uniqueSelection = false,
    periodGroup = false,
}) => {
    const activateModel = (activeValue, modelIndex) => {
        let newModels = [...models];
        if (uniqueSelection && activeValue) {
            // If uniqueSelection is enabled and we're activating a model,
            // deactivate all others first
            newModels = newModels.map((m, idx) => ({
                ...m,
                Active: idx === modelIndex,
            }));
        } else {
            newModels[modelIndex].Active = activeValue;
        }
        updateModels(newModels);
    };

    const activateAll = () => {
        let newModels = models.map((m) => ({ ...m, Active: !m.AlwaysCancelled }));
        updateModels(newModels);
    };

    const deactivateAll = () => {
        let newModels = models.map((m) => ({ ...m, Active: false }));
        updateModels(newModels);
    };

    const selectionActions = [
        { label: 'select all', method: activateAll },
        { label: 'deselect all', method: deactivateAll },
    ];

    // For CustomSelect in uniqueSelection mode
    const handleSelectChange = (modelId) => {
        let newModels = models.map((m) => ({
            ...m,
            Active: m.ModelID === modelId,
        }));
        updateModels(newModels);
    };

    const getSelectedModelId = () => {
        const activeModel = models.find((m) => m.Active);
        return activeModel ? activeModel.ModelID : null;
    };

    const selectOptions = models.map((model) => ({
        value: model.ModelID,
        label: model.ModelName,
    }));

    return (
        <ModelSelectorContainer>
            {uniqueSelection ? (
                <CustomSelect
                    value={getSelectedModelId()}
                    onChange={handleSelectChange}
                    options={selectOptions}
                    placeholder="Select a model"
                    style={{ width: '100%' }}
                />
            ) : (
                <>
                    {periodGroup ? (
                        <h1>Dates</h1>
                    ) : (
                        <h1>{uniqueSelection ? 'Model' : selectedEvent ? 'Models' : 'Models in current project'}</h1>
                    )}
                    <SelectionBar actions={selectionActions} />
                    {models.map((model, index) => {
                        return (
                            <div className="model-wrapper" key={model.ModelID}>
                                <StyledSwitch
                                    $cancel={model.AlwaysCancelled}
                                    text={model.ModelName}
                                    checked={model.Active}
                                    onChange={(value) => activateModel(value, index)}
                                />
                            </div>
                        );
                    })}
                </>
            )}
        </ModelSelectorContainer>
    );
};

export default ModelSelectorNonBookingDates;
